import {BaseApi} from './base-api';
import Vue from 'vue';

export class ObjectApi extends BaseApi {
  static apiUri = 'objects';

  /** @return {Promise<PagedHttpResponse<ObjectBasicDto>>} */
  static getAll () {
    return super.getAll();
  }

  /** @return {Promise<>} */
  static assignGroups (groupsAssignments) {
    return Vue.http.post(this.apiUri + '/assignGroups', groupsAssignments);
  }

  /** @return {Promise<EntityHttpResponse<ObjectDto>>} */
  static getById (id) {
    return super.getById(id);
  }

  /** @return {Promise<EntityHttpResponse<ObjectDto>>} */
  static updateObject (id, objectUpdateRequest) {
    return Vue.http.patch(this.apiUri + '/' + id, objectUpdateRequest)
  }
}
